import script from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=2829f4f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2829f4f2"]])

export default __exports__